import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=851f905e&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=851f905e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851f905e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('851f905e')) {
      api.createRecord('851f905e', component.options)
    } else {
      api.reload('851f905e', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=851f905e&scoped=true&", function () {
      api.rerender('851f905e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21QE22aZ8kDkx/JS/comp/PopupDialog.vue"
export default component.exports